import React from 'react';

import styles from './styled-billing.module.scss';
export const HeaderWrapper = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['header-wrapper']} ${className}` : styles['header-wrapper']}
    {...props}
  />
);

export const Header = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['header']} ${className}` : styles['header']} {...props} />
);

export const ItemsContainer = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['items-container']} ${className}` : styles['items-container']}
    {...props}
  />
);
